import React, {useState, useEffect} from 'react';
import {View, ScrollView, useWindowDimensions, StyleSheet} from 'react-native';
import Text from '../../../components/Text';
import MaterialCommunityIcons from '@expo/vector-icons/MaterialCommunityIcons';
import {showErrorMessage} from '../../../service/flashMessage';
import {createUnitPeopleConnector} from '../../../api/connector';
import Navbar from '../../../components/Navbar';
import {initialUnitPeopleConnectorState} from '../utils';
import {useSelector} from 'react-redux';
import {RootStore} from '../../../redux/store';
import {ActivityIndicator} from 'react-native-paper';
import Button from '../../../components/Button';
import Input from '../../../components/Input';
import ScreenWrapper from '../../Auth/components/ScreenWrapper';
import {copyToClipboard} from '../../../service/clipboard';
import isWeb from '../../../utils/isWeb';

const LinkCodeGenerator = ({navigation}) => {
  const personId = useSelector((state: RootStore) => state.auth.user.id);
  // const unitId = useSelector((state) => state.defaultUnit).id;
  const [unitPeopleConnectorState, setUnitPeopleConnectorState] = useState({
    ...initialUnitPeopleConnectorState,
    peopleId: personId,
    // unitId: unitId,
  });
  const [isSubmitting, setIsSubmitting] = useState(true);
  const [linkCode, setLinkCode] = useState('');

  const {width} = useWindowDimensions();

  useEffect(() => {
    submitUnitPeopleConnector(unitPeopleConnectorState);
  }, [unitPeopleConnectorState]);

  const submitUnitPeopleConnector = async connector => {
    try {
      const link = await createUnitPeopleConnector(connector);
      setLinkCode(link.linkCode);
    } catch (e) {
      showErrorMessage('LinkCodeGenerator: ' + e.message);
    }
    setIsSubmitting(false);
  };

  return (
    <View style={styles.container}>
      <Navbar navigation={navigation} title="People link code" />
      <ScreenWrapper>
        {isSubmitting ? (
          <ActivityIndicator />
        ) : (
          <ScrollView
            style={[
              isWeb && {
                flex: 1,
                margin: 16,
                width: width / 3,
                backgroundColor: '#ffffff',
                paddingHorizontal: 32,
              },
              styles.scrollView,
            ]}>
            <>
              <Text style={styles.codeText}>Your code is:</Text>
              <Input
                mt={4}
                mb={4}
                value={linkCode}
                isReadOnly={true}
                size="lg"
                px={3}
                InputRightElement={
                  <Button
                    variant="ghost"
                    startIcon={
                      <MaterialCommunityIcons
                        name="content-paste"
                        color="gray"
                        size={24}
                      />
                    }
                    onPress={() => {
                      copyToClipboard(linkCode);
                    }}>
                    {`Copy `}
                  </Button>
                }
                style={styles.input}
              />
              <Text style={styles.descriptionText}>
                This code is typically given to a resident with permission to
                add visitors or vendors in their unit.
              </Text>
              <Text style={styles.descriptionText}>
                They use this code to link you to their unit. once linked you
                can see if you have permission to enter and request access if
                you don not.
              </Text>
              <Text style={styles.descriptionText}>
                This code is invalid after 24 hours
              </Text>
            </>
          </ScrollView>
        )}
      </ScreenWrapper>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    marginBottom: 2,
  },
  scrollView: {
    margin: 16,
    flex: 1,
  },
  codeText: {
    flex: 1,
    marginTop: 6,
  },
  input: {
    fontFamily: 'RobotoMono-Regular',
    fontSize: 24,
    textAlign: 'center',
  },
  descriptionText: {
    fontSize: 20,
    marginTop: 12,
    marginBottom: 2,
  },
});

export default LinkCodeGenerator;
